import "./onevacancy.scss";
import fire from "../images/fire.svg";
import { inject, observer } from "mobx-react";
import { useNavigate } from "react-router-dom";

import moment from "moment";

const OneVacancy = ({
  position,
  date,
  description,
  salary,
  worklocation,
  hot,
  token,
  setSignInModal,
  id
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    token ? navigate(`/allvacancies/${id}`) : setSignInModal(true);
  };

  return (
    <div
      className={`card-vacancy ${hot === "1" && "hotvacancy"}`}
      onClick={handleClick}
    >
      <div className="card-vacancy__cols">
        <div className="card-vacancy__cols">
          {hot === "1" && (
            <img src={fire} className="card-vacancy__img" alt="" />
          )}
          <p className="card-vacancy__text-date">{moment(date).format("L")}</p>
        </div>
        <p
          className={`card-vacancy__text-small card-vacancy__text-link ${
            hot === "1" ? "hotvacancy__color-text" : "normalvacancy__color-text"
          }`}
        >
          Подробнее
        </p>
      </div>
      <p
        className={`card-vacancy__text-position ${
          hot === "1" ? "hotvacancy__color-text" : "normalvacancy__color-text"
        }`}
      >
        {position.split(/ (\d)/)[0]}
      </p>

      <div className="card-vacancy__cols">
        <p
          className={`card-vacancy__text-city ${
            hot === "1" ? "hotvacancy__color-text" : "normalvacancy__color-text"
          }`}
        >
          {worklocation.length > 0 ? <>г. {worklocation}</> : "Вся Россия"}
        </p>
        <p className="card-vacancy__text-city">{salary} руб</p>
      </div>

      <p className="card-vacancy__text-description">
        {description
          .replace(/<\/?[^>]+(>|$)/g, "")
          .replace(/&nbsp;/g, " ")
          .substring(0, 90)}
        ...
      </p>

      {/* Вознаграждение скрыто в задаче FRONT-843 */}
      {/* {token ? (
        <div className="card-vacancy__cols">
          <p className="card-vacancy__text-small">Ваше вознаграждение:</p>
          <p
            className={`card-vacancy__text-agentSalary ${
              hot === "1"
                ? "hotvacancy__color-text"
                : "normalvacancy__color-text"
            }`}
          >
            {agentSalary} руб
          </p>
        </div>
      ) : (
        ""
      )} */}
    </div>
  );
};

export default inject(({ usersStore }) => {
  const { token } = usersStore;
  return {
    token
  };
})(observer(OneVacancy));
